import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Text,
  useColorMode,
  Spacer,
  Badge,
  IconButton,
} from "@chakra-ui/react";
import { useHistory, useLocation } from "react-router-dom";
import SettingsMenu from "../common/SettingsMenu";
import { getNotificationCounts } from "../../api/problemReports";
import { useOTP } from "../AdminPanelAccess/OTPContext";

const AdminHeader = ({ title, downloadButton }) => {
  const history = useHistory();
  const location = useLocation();
  const { colorMode } = useColorMode();
  const { isOTPVerified } = useOTP();

  const [notificationCounts, setNotificationCounts] = useState({
    unresponded_problems: 0,
    unresponded_applications: 0,
    unread_emails: 0,
    total_notifications: 0,
  });

  const fetchNotificationCounts = async () => {
    try {
      const response = await getNotificationCounts();
      if (response.success) {
        setNotificationCounts(response.data);
      }
    } catch (err) {
      console.error("Failed to fetch notification counts:", err);
    }
  };

  useEffect(() => {
    fetchNotificationCounts();
  }, []);

  // Helper function to determine if a button should be highlighted
  const isActiveButton = (path) => {
    if (path === "/admin/mailbox") {
      return location.pathname === "/admin/mailbox";
    } else if (path === "/admin/userform") {
      return location.pathname === "/admin/userform";
    } else if (path === "/admin/report/problem") {
      return location.pathname === "/admin/report/problem";
    }
    return false;
  };

  // Don't render header if OTP is not verified
  if (!isOTPVerified) {
    return null;
  }

  return (
    <Box
      flex="1"
      display="flex"
      flexDirection="column"
      maxH="8vh"
      borderBottom="1px"
      borderColor="blackAlpha.200"
      overflowY="hidden"
    >
      <Box
        display="flex"
        alignItems="center"
        bg={colorMode === "dark" ? "gray.700" : "white"}
        width="100%"
        height="100%"
        p={4}
        pt={2}
        pb={2}
        boxSizing="border-box"
        overflowY="hidden"
      >
        <Text
          fontSize="md"
          fontWeight="bold"
          mb={0}
          mt={0}
          color={colorMode === "dark" ? "gray.200" : "blackAlpha.700"}
        >
          {title}
        </Text>
        <Spacer />
        {downloadButton && downloadButton}
        <Box position="relative">
          <Button
            bg={isActiveButton("/admin/mailbox") ? "#286328" : "gray.300"}
            color={isActiveButton("/admin/mailbox") ? "white" : "black"}
            _hover="none"
            size="sm"
            onClick={() => {
              history.push("/admin/mailbox");
            }}
            ml={2}
          >
            Info Mailbox
          </Button>
          {notificationCounts.unread_emails > 0 && (
            <Badge
              position="absolute"
              top="-8px"
              right="-8px"
              bg="red.500"
              color="white"
              borderRadius="full"
              fontSize="xs"
              minW="20px"
              h="20px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {notificationCounts.unread_emails}
            </Badge>
          )}
        </Box>
        <Box position="relative">
          <Button
            bg={isActiveButton("/admin/userform") ? "#286328" : "gray.300"}
            color={isActiveButton("/admin/userform") ? "white" : "black"}
            _hover="none"
            size="sm"
            onClick={() => {
              history.push("/admin/userform");
            }}
            ml={2}
          >
            Partner Applications
          </Button>

          {notificationCounts.unresponded_applications > 0 && (
            <Badge
              position="absolute"
              top="-8px"
              right="-8px"
              bg="red.500"
              color="white"
              borderRadius="full"
              fontSize="xs"
              minW="20px"
              h="20px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {notificationCounts.unresponded_applications}
            </Badge>
          )}
        </Box>
        <Box position="relative">
          <Button
            bg={
              isActiveButton("/admin/report/problem") ? "#286328" : "gray.300"
            }
            color={isActiveButton("/admin/report/problem") ? "white" : "black"}
            _hover="none"
            size="sm"
            onClick={() => {
              history.push("/admin/report/problem");
            }}
            ml={2}
          >
            Report a Problem
          </Button>
          {notificationCounts.unresponded_problems > 0 && (
            <Badge
              position="absolute"
              top="-8px"
              right="-8px"
              bg="red.500"
              color="white"
              borderRadius="full"
              fontSize="xs"
              minW="20px"
              h="20px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {notificationCounts.unresponded_problems}
            </Badge>
          )}
        </Box>
        <SettingsMenu />
      </Box>
    </Box>
  );
};

export default AdminHeader;
